// extracted by mini-css-extract-plugin
module.exports =  {"root":"F2OMhhvhJDOhCxpJV9Ew","large":"yImavsWfkPEM6S4htKYy","medium":"L_w2k6nUUlZoJmcYoMyo"};